import { render } from "./eliminacionMasiva.vue?vue&type=template&id=7613cc18&scoped=true"
import script from "./eliminacionMasiva.vue?vue&type=script&lang=js"
export * from "./eliminacionMasiva.vue?vue&type=script&lang=js"

import "./eliminacionMasiva.vue?vue&type=style&index=0&id=7613cc18&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7613cc18"]])

export default __exports__